function getSessionId(item) {
  return String(item?.sessionId || item?.session_id || item?.id || '').trim();
}

export function selectActiveSession(sessions, activeSessionId) {
  return sessions.find((item) => {
    const sessionId = getSessionId(item);
    return Boolean(sessionId && sessionId === activeSessionId);
  }) || null;
}

function projectTimestamps(session) {
  return {
    updatedAt: session.updatedAt || session.updated_at || new Date().toISOString(),
    createdAt: session.createdAt || session.created_at || new Date().toISOString(),
  };
}

export function selectProjectItems({
  projectId,
  projectDisplayName,
  sessions,
}) {
  const sessionItems = Array.isArray(sessions) ? sessions : [];
  if (sessionItems.length <= 0) {
    return [];
  }
  const firstSession = sessionItems[0] ?? {};
  return [{
    key: String(projectId || firstSession.project_id || firstSession.session_id || firstSession.id || '').trim(),
    project_id: projectId,
    name: projectDisplayName,
    ...projectTimestamps(firstSession),
  }];
}
